export const POPULAR_SEARCHES = [
  'Pain relief',
  'Blood pressure',
  'Diabetes',
  'Vitamins',
  'First aid',
  'Paracetamol',
  'Omega-3',
  'Face Masks',
  'Thermometer',
]

export const TRENDING_SEARCHES = [
  'aspirin',
  'blood pressure monitor',
  'vitamin d',
  'insulin',
  'blood glucose meter',
  'multivitamin',
  'first aid kit',
  'thermometer',
]

export const TRENDING_PRODUCTS = [
  {
    id: 101,
    name: 'Panadol Extra Pain Relief Tablets 24s',
    price: 12.99,
    originalPrice: 15.99,
    discount: 19,
    image:
      'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop',
    category: 'Pain Relief',
  },
  {
    id: 102,
    name: 'Vitamin D3 1000 IU Supplement 60 Capsules',
    price: 24.99,
    originalPrice: 24.99,
    discount: 0,
    image:
      'https://images.unsplash.com/photo-1550572017-4bfa2d5c8f1d?w=400&h=400&fit=crop',
    category: 'Vitamins',
  },
  {
    id: 103,
    name: 'Digital Blood Pressure Monitor',
    price: 89.99,
    originalPrice: 89.99,
    discount: 0,
    image:
      'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=400&h=400&fit=crop',
    category: 'Medical Devices',
  },
  {
    id: 104,
    name: 'First Aid Emergency Kit',
    price: 45.99,
    originalPrice: 58.99,
    discount: 22,
    image:
      'https://images.unsplash.com/photo-1603398938378-e54eab446dde?w=400&h=400&fit=crop',
    category: 'First Aid',
  },
]
